export default "__VITE_ASSET__CrgnBrd7__"